<template>
  <img src="http://cert.szhyudiao.com/szh/banner.png" class="banner" />
</template>
<script>
export default {
  name: "Banner",
};
</script>
<style scoped>
.banner {
  width: 100%;
  display: block;
}
</style>